import { useEffect, useRef, useState } from 'react'
import { WaterNeuron } from '../../clients/WaterNeuron'
import { useCurrentWallet } from '../../state'
import { logger } from '../../logger'
import { getIdentity } from '../../handlers/walletActions/wallet'
import getAgent from '../../utils/getAgent'
import useConfig from '../../hooks/useConfig'
import { WaterNeuronInfo } from '../../interfaces/staking'
import { ICToken } from '../../interfaces/common'
import { ICP_ICP_ID, NICP_ICP_ID } from '../../constants/tokenIds'

export const useWaterNeuron = () => {
  const { tokens } = useConfig()
  const { currentWallet: principal } = useCurrentWallet()

  const [hasWnError, setHasWnError] = useState(false)
  const [wnInfo, setWnInfo] = useState<WaterNeuronInfo>({
    exchange_rate: 0n,
    total_icp_deposited: 0n,
    minimum_deposit_amount: 0n,
    minimum_withdraw_amount: 0n,
  })

  const waterNeuron = useRef<WaterNeuron>()

  const icpToken = tokens.find((t): t is ICToken => t.id === ICP_ICP_ID)
  const nicpToken = tokens.find((t): t is ICToken => t.id === NICP_ICP_ID)

  useEffect(() => {
    getIdentity(principal).then(async (identity) => {
      const agent = getAgent({ identity })

      waterNeuron.current = new WaterNeuron(agent)

      try {
        const info = await waterNeuron.current.getInfo()

        setWnInfo(info)
      } catch (e) {
        setHasWnError(true)

        logger.error('Failed to fetch Water Neuron info', { originalError: e })
      }
    })
  }, [])

  return {
    hasWnError,
    wnInfo,
    waterNeuron,
    icpToken,
    nicpToken,
  }
}
